import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Row } from 'react-bootstrap';
import { certificationActions } from 'store/slices/certification/certificationSilce';

import SuccessHeader from './SuccessHeader';
import SuccessScoreTable from './SuccessScoreTable';
import useEpstSuccess from 'hooks/certification/epst/useEpstSuccess';

import styles from 'assets/scss/wizard/emetSuccess.module.scss';


/**
 * @component Success
 * @description
 * Componente que representa la pantalla de éxito al finalizar el examen EPST.
 * - Utiliza el hook `useEpstSuccess` para gestionar la lógica de obtención y generación de resultados.
 * - Muestra los resultados por sección a través del componente `SuccessScoreTable`.
 * - Permite al usuario finalizar el proceso y regresar al inicio.
 *
 * @param {Object} props
 * @param {Object} props.certification - Objeto de certificación que contiene información relevante como ID y college_id.
 *
 * @returns {JSX.Element} Componente visual de finalización del examen.
 *
 * @example
 * <Success certification={certificationData} />
 */
const Success = ({ certification }) => {
	const token = useSelector(state => state.authentication.user?.token);
	const username = useSelector(state => state.authentication.user?.username);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	/**
	 * Limpia el estado global y redirige al usuario al inicio.
	 */
	const handleFinish = () => {
		dispatch(certificationActions.resetCertification());
		navigate('/');
	};

	// Hook personalizado que gestiona la lógica del resultado EPST
	const { epstScores } = useEpstSuccess({
		certification,
		token,
		username,
		onFinished: handleFinish
	});

	return (
		<Row className={styles.centerItems}>
			<SuccessHeader onFinish={handleFinish} />
			<SuccessScoreTable scores={epstScores} />
		</Row>
	);
};

export default Success;